import {BaseService} from "./BaseService";
import {LocationHistory} from "../entities/LocationHistory";
import { StateService } from "@uirouter/angularjs";

export class LocationHistoryService extends BaseService<LocationHistory>{
    static $inject = ['$http','$q','$state'];
    constructor($http: ng.IHttpService, $q: ng.IQService, $state: StateService) {
        super($http, $q, $state, LocationHistory);
    }
    protected getBaseUrl():string{
        return "locationhistory";
    }
    protected getBasesUrl():string{
        return "locationhistories";
    }
    getByAsset(assetId:number):ng.IPromise<LocationHistory[]>{
        var config:any = {};
        return this.useBaseGetArrayHandler(this.getBasesUrl(),"asset/"+assetId, config);
    }
    getReport(groupByAsset:boolean,name:string,location:string,assetType:string,department:string,disposalStatus:string,checkinStatus:string,missing:string,tagType:string){
        var config:any = {
            headers: {
                'Content-type': 'application/json',
                'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            },
            responseType: 'arraybuffer'
        };
        var timeZoneId = Intl.DateTimeFormat().resolvedOptions().timeZone;
        return this.useGetHandler("Report", "LocationHistory?timeZoneId=" + timeZoneId + "&groupByAsset="+groupByAsset+"&name="+name+"&location="+location+"&assetType="+assetType+"&department="+department+"&disposalStatus="
            +disposalStatus+"&checkinStatus="+checkinStatus+"&missing="+missing+"&tagType="+tagType, config);
    }
    getReportCount(groupByAsset:boolean,name:string,location:string,assetType:string,department:string,disposalStatus:string,checkinStatus:string,missing:string,tagType:string){
        var config:any = {};
        return this.useGetHandler(this.getBasesUrl(),"ReportCount?groupByAsset="+groupByAsset+"&name="+name+"&location="+location+"&assetType="+assetType+"&department="+department+"&disposalStatus="
            + disposalStatus + "&checkinStatus=" + checkinStatus + "&missing=" + missing + "&tagType=" + tagType, config);
    }
    getReportItems(groupByAsset:boolean,name:string,location:string,assetType:string,department:string,disposalStatus:string,checkinStatus:string,missing:string):ng.IPromise<LocationHistory[]>{
        var config:any = {};
        return this.useBaseGetArrayHandler(this.getBasesUrl(),"Report?groupByAsset="+groupByAsset+"&name="+name+"&location="+location+"&assetType="+assetType+"&department="+department+"&disposalStatus="
            +disposalStatus+"&checkinStatus="+checkinStatus+"&missing="+missing, config);
    }
}
